<mat-toolbar class="nav-bar">
  <div class="logo pointer">
    <img [ngSrc]="appStore.theme() === 'dark' ? 'assets/images/djlogo.png' : 'assets/images/light-dj-logo.png'" height="30" width="40" alt="logo" priority (click)="goMain()">
  </div>

<!--  <span class="spacer"></span>-->
  @if(userStore.user()) {
    <div class="top-menu">
      <a class="nav-item" routerLink="library" routerLinkActive="active-link">

        <span>Library</span>
      </a>

      <a class="nav-item" routerLink="playlists" routerLinkActive="active-link">

        <span>Playlists</span>
      </a>
    </div>
  } @else {
    <span class="spacer"></span>
  }



  @if (!hasRoute('admin')) {
    <app-theme-picker></app-theme-picker>
  }
  @if(userStore.user()) {
    <a [matMenuTriggerFor]="menu" class="user-menu">
      <div class="d-flex align-center pointer">
        {{userStore.user()!.email}}
        <mat-icon>arrow_drop_down</mat-icon>
      </div>

    </a>

    <mat-menu #menu="matMenu">
      @if (userStore.user()?.role === UserRoles.Admin) {
        <button mat-menu-item (click)="goAdmin()">
          <span>Admin Panel</span>
        </button>
      }
      <button mat-menu-item (click)="goProfile()">
        <span>Profile</span>
      </button>
      <a mat-menu-item routerLink="/faq">
        <span>FAQ</span>
      </a>
      <a mat-menu-item routerLink="/contact-us">
        <span>Support</span>
      </a>
      <button mat-menu-item (click)="logout()">
        <span>Logout</span>
      </button>
    </mat-menu>
  } @else {
    <button matButton="filled" class="button-regular" style="font-size: 16px; font-weight: 400;" [routerLink]="['/login']">Login</button>
  }


</mat-toolbar>

<ng-content>
</ng-content>

@if(playerSource.currentTrack()) {
  <app-player-bar></app-player-bar>
}

@if (!hasRoute('admin')) {
  <div class="footer">
    <div class="main-block">
<!--      <span class="spacer"></span>-->
      <img src="assets/images/logo-footer.png" style="width: 160px; height: 40px;" alt="footer logo">
      <div class="footer-links">
        <div class="block-title">Company</div>

        <a class="block-link" routerLink="/about-us">About Us</a>
        <a class="block-link" routerLink="/faq">FAQ</a>
        <a class="block-link" routerLink="/contact-us">Contact Us</a>



      </div>
      <div class="footer-links">
        <div class="block-title">Policy</div>

        <a class="block-link" routerLink="/terms-and-conditions">Terms And Conditions</a>
        <a class="block-link" routerLink="/privacy-policy">Privacy Policy</a>
        <a class="block-link" routerLink="/dmca">DMCA Form</a>

      </div>
      <div class="footer-links">
        <div class="block-title">Follow us</div>
        <div class="social-items">
          <a href="https://facebook.com/Djmixinglab" target="_blank">
            <svg width="24" height="24" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.7112 1.66675C3.02539 1.66675 1.66797 3.02416 1.66797 4.70998V15.2902C1.66797 16.976 3.02539 18.3334 4.7112 18.3334H10.4456V11.8178H8.72267V9.47197H10.4456V7.4678C10.4456 5.89322 11.4636 4.44748 13.8086 4.44748C14.7581 4.44748 15.4602 4.53863 15.4602 4.53863L15.405 6.72927C15.405 6.72927 14.6889 6.7225 13.9076 6.7225C13.0619 6.7225 12.9263 7.11213 12.9263 7.75897V9.47198H15.4721L15.3612 11.8178H12.9263V18.3335H15.2914C16.9772 18.3335 18.3346 16.976 18.3346 15.2902V4.71C18.3346 3.02418 16.9772 1.66676 15.2914 1.66676H4.71119L4.7112 1.66675Z"/>
            </svg>

          </a>
          <a href="https://instagram.com/Djmixinglab" target="_blank">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9.52C11.5095 9.52 11.03 9.66545 10.6222 9.93795C10.2144 10.2105 9.89648 10.5978 9.70878 11.0509C9.52107 11.5041 9.47196 12.0028 9.56765 12.4838C9.66334 12.9649 9.89954 13.4068 10.2464 13.7536C10.5932 14.1005 11.0351 14.3367 11.5162 14.4323C11.9972 14.528 12.4959 14.4789 12.9491 14.2912C13.4022 14.1035 13.7895 13.7856 14.062 13.3778C14.3346 12.97 14.48 12.4905 14.48 12C14.48 11.6743 14.4159 11.3518 14.2912 11.0509C14.1666 10.7501 13.9839 10.4767 13.7536 10.2464C13.5233 10.0161 13.2499 9.83341 12.9491 9.70878C12.6482 9.58415 12.3257 9.52 12 9.52ZM21.93 7.07C21.9247 6.29776 21.7825 5.53257 21.51 4.81C21.3093 4.28126 20.9987 3.80109 20.5988 3.40119C20.1989 3.00128 19.7187 2.69072 19.19 2.49C18.4674 2.21746 17.7022 2.07526 16.93 2.07C15.64 2 15.26 2 12 2C8.74 2 8.36 2 7.07 2.07C6.29776 2.07526 5.53257 2.21746 4.81 2.49C4.28126 2.69072 3.80109 3.00128 3.40119 3.40119C3.00128 3.80109 2.69072 4.28126 2.49 4.81C2.21746 5.53257 2.07526 6.29776 2.07 7.07C2 8.36 2 8.74 2 12C2 15.26 2 15.64 2.07 16.93C2.08076 17.705 2.22277 18.4725 2.49 19.2C2.68983 19.7263 3.00013 20.2037 3.4 20.6C3.79819 21.0023 4.27939 21.3129 4.81 21.51C5.53257 21.7825 6.29776 21.9247 7.07 21.93C8.36 22 8.74 22 12 22C15.26 22 15.64 22 16.93 21.93C17.7022 21.9247 18.4674 21.7825 19.19 21.51C19.7206 21.3129 20.2018 21.0023 20.6 20.6C20.9999 20.2037 21.3102 19.7263 21.51 19.2C21.7823 18.4739 21.9244 17.7055 21.93 16.93C22 15.64 22 15.26 22 12C22 8.74 22 8.36 21.93 7.07ZM19.39 15.07C19.3579 15.6871 19.2262 16.295 19 16.87C18.8059 17.3497 18.5173 17.7854 18.1514 18.1514C17.7854 18.5173 17.3497 18.8059 16.87 19C16.2895 19.2136 15.6783 19.3318 15.06 19.35C14.27 19.35 14.06 19.35 12 19.35C9.94 19.35 9.73 19.35 8.94 19.35C8.32173 19.3318 7.71049 19.2136 7.13 19C6.6341 18.8157 6.18628 18.5217 5.82 18.14C5.45767 17.7813 5.17784 17.3479 5 16.87C4.78556 16.2901 4.67061 15.6782 4.66 15.06C4.66 14.27 4.66 14.06 4.66 12C4.66 9.94 4.66 9.73 4.66 8.94C4.67061 8.32183 4.78556 7.70988 5 7.13C5.18428 6.6341 5.47827 6.18628 5.86 5.82C6.22033 5.45962 6.65326 5.18009 7.13 5C7.71049 4.78641 8.32173 4.66821 8.94 4.65C9.73 4.65 9.94 4.65 12 4.65C14.06 4.65 14.27 4.65 15.06 4.65C15.6783 4.66821 16.2895 4.78641 16.87 5C17.3659 5.18428 17.8137 5.47827 18.18 5.86C18.5423 6.21875 18.8222 6.65213 19 7.13C19.2136 7.71049 19.3318 8.32173 19.35 8.94C19.35 9.73 19.35 9.94 19.35 12C19.35 14.06 19.42 14.27 19.39 15.06V15.07ZM17.79 7.63C17.6709 7.30698 17.4832 7.01364 17.2398 6.77021C16.9964 6.52678 16.703 6.33906 16.38 6.22C15.9365 6.06626 15.4693 5.99179 15 6C14.22 6 14 6 12 6C10 6 9.78 6 9 6C8.52827 6.00461 8.06107 6.09263 7.62 6.26C7.30193 6.37366 7.01169 6.55371 6.76858 6.7882C6.52547 7.02269 6.33506 7.30624 6.21 7.62C6.06478 8.06537 5.99383 8.5316 6 9C6 9.78 6 10 6 12C6 14 6 14.22 6 15C6.00991 15.4712 6.09777 15.9375 6.26 16.38C6.37906 16.703 6.56678 16.9964 6.81021 17.2398C7.05364 17.4832 7.34698 17.6709 7.67 17.79C8.09667 17.9469 8.54565 18.0347 9 18.05C9.78 18.05 10 18.05 12 18.05C14 18.05 14.22 18.05 15 18.05C15.4717 18.0454 15.9389 17.9574 16.38 17.79C16.703 17.6709 16.9964 17.4832 17.2398 17.2398C17.4832 16.9964 17.6709 16.703 17.79 16.38C17.9574 15.9389 18.0454 15.4717 18.05 15C18.05 14.22 18.05 14 18.05 12C18.05 10 18.05 9.78 18.05 9C18.0503 8.5278 17.9621 8.05972 17.79 7.62V7.63ZM12 15.82C11.4988 15.82 11.0026 15.7211 10.5397 15.529C10.0768 15.3369 9.6563 15.0554 9.30238 14.7005C8.94846 14.3457 8.66803 13.9245 8.47714 13.4611C8.28626 12.9977 8.18868 12.5012 8.19 12C8.19 11.2441 8.4143 10.5051 8.83449 9.87669C9.25468 9.24828 9.85187 8.75866 10.5505 8.46983C11.2491 8.181 12.0177 8.10594 12.7589 8.25415C13.5002 8.40236 14.1808 8.76717 14.7147 9.30241C15.2485 9.83764 15.6116 10.5192 15.7578 11.2609C15.9041 12.0026 15.827 12.771 15.5363 13.4688C15.2457 14.1666 14.7545 14.7625 14.125 15.1811C13.4955 15.5996 12.7559 15.822 12 15.82ZM16 8.93C15.7789 8.9066 15.5744 8.80222 15.4257 8.63697C15.277 8.47172 15.1947 8.25729 15.1947 8.035C15.1947 7.81271 15.277 7.59828 15.4257 7.43303C15.5744 7.26778 15.7789 7.1634 16 7.14C16.2211 7.1634 16.4256 7.26778 16.5743 7.43303C16.723 7.59828 16.8053 7.81271 16.8053 8.035C16.8053 8.25729 16.723 8.47172 16.5743 8.63697C16.4256 8.80222 16.2211 8.9066 16 8.93Z"/>
            </svg>

          </a>
          <a href="https://x.com/Djmixinglab" target="_blank">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.6562 2C20.9507 2 22 3.04933 22 4.34375V19.6562C22 20.9507 20.9507 22 19.6562 22H4.34375C3.04933 22 2 20.9507 2 19.6562V4.34375C2 3.04933 3.04933 2 4.34375 2H19.6562ZM5.28418 5.90625L10.3809 12.5723L5.5498 18.0938H7.61914L11.3477 13.833L14.6064 18.0938H18.7666L13.4531 11.0684L17.9697 5.90625H15.9023L12.4961 9.80078L9.5498 5.90625H5.28418ZM8.92773 7.0791L16.3223 16.8564H15.1768L7.69824 7.0791H8.92773Z"/>
            </svg>

          </a>
<!--          <a href="https://youtube.com/Djmixinglab" target="_blank">-->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M23 9.70998C23.0495 8.27864 22.7365 6.858 22.09 5.57998C21.6514 5.05558 21.0427 4.70169 20.37 4.57998C17.5875 4.32751 14.7936 4.22403 12 4.26998C9.21667 4.22194 6.43274 4.32208 3.66003 4.56998C3.11185 4.6697 2.60454 4.92683 2.20003 5.30998C1.30003 6.13998 1.20003 7.55998 1.10003 8.75998C0.954939 10.9175 0.954939 13.0824 1.10003 15.24C1.12896 15.9154 1.22952 16.5858 1.40003 17.24C1.5206 17.745 1.76455 18.2123 2.11003 18.6C2.51729 19.0034 3.03641 19.2752 3.60003 19.38C5.75594 19.6461 7.92824 19.7564 10.1 19.71C13.6 19.76 16.67 19.71 20.3 19.43C20.8775 19.3316 21.4112 19.0595 21.83 18.65C22.11 18.3699 22.3191 18.0271 22.44 17.65C22.7977 16.5526 22.9733 15.4041 22.96 14.25C23 13.69 23 10.31 23 9.70998ZM9.74003 14.85V8.65998L15.66 11.77C14 12.69 11.81 13.73 9.74003 14.85Z" />-->
<!--            </svg>-->
<!--          </a>-->

<!--          <a href="https://www.tiktok.com/" target="_blank">-->
<!--            &lt;!&ndash; Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools &ndash;&gt;-->
<!--            <svg width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">-->
<!--              <title>tiktok</title>-->
<!--              <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path>-->
<!--            </svg>-->
<!--          </a>-->

        </div>
      </div>
<!--      <span class="spacer"></span>-->
    </div>
    <div class="bottom-block">
      © 2021 DJ Mixing Lab | All Rights Reserved
    </div>


  </div>
}


